import Cookies from "js-cookie";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import HeroPill from "./HeroPill";
import { useTranslation } from "react-i18next";

const HeroSection = () => {
  const navigate = useNavigate();

  const { t } = useTranslation('home');

  const tokenCookie = Cookies.get("token", { domain: config.cookieDomain });
  const isPaidCookie = Cookies.get("role", { domain: config.cookieDomain });
  const isTestTaken = Cookies.get("isTestAttended", {
    domain: config.cookieDomain,
  });

  const handleTakeTest = () => {
    // if (tokenCookie) {
    //   if (isPaidCookie && isPaidCookie === "ROLE_UNPAID_USER") {
    //     localStorage.setItem('redirectTo', JSON.stringify('home'));
    //     navigate("/home");
    //   } else {
    //     navigate("/instruction");
    //   }
    // } else {
    //   navigate("/instruction");
    // }
    navigate("/instruction");
  };

  return (
    <section className="h-[calc(100vh-80px)] bg-gradient-to-r from-[#3B75DD] via-[#7768FC] to-[#99A6D5] relative flex text-white justify-center items-center">
      <div className="absolute top-1/2 -translate-y-1/2 left-[5%] md-max:hidden lg:lg-small:scale-75 lg:lg-small:left-[1rem] flex flex-col gap-[15vh] lg:lg-small:gap-[300px]">
        <HeroPill
          className={"ml-10"}
          title={t('hero.pill1')}
          subTitle={t('hero.subPill1')}
          count={"10"}
          icon={"hero-icon-2.png"}
        />
        <HeroPill
          className={"mr-10"}
          title={t('hero.pill2')}
          subTitle={t('hero.subPill2')}
          count={"1500"}
          icon={"hero-icon-4.png"}
        />
      </div>
      <div className="absolute top-1/2 -translate-y-1/2 right-[5%] md-max:hidden lg:lg-small:scale-75 lg:lg-small:right-[1rem] flex flex-col gap-[15vh] lg:lg-small:gap-[300px]">
        <HeroPill
          className={"to-[#8A7FFB] ml-10 -mt-[2rem]"}
          title={t('hero.pill3')}
          subTitle={t('hero.subPill3')}
          percent={true}
          count={"97"}
          icon={"hero-icon-3.png"}
        />
        <HeroPill
          className={"to-[#8A7FFB] mr-10 mt-[2rem]"}
          title={t('hero.pill4')}
          subTitle={t('hero.subPill4')}
          count={"1000"}
          icon={"hero-icon-1.png"}
        />
      </div>
      <img
        src="/hero-bgr.png"
        alt=""
        className="absolute top-1/2 left-1/2 -translate-x-1/2 z-30 h-full w-full object-cover"
      />
      <img
        src="/hero-vector.svg"
        alt=""
        className="absolute top-full left-0 scale-x-[-1] z-30 size-[80px] object-cover"
      />
      <img
        src="/hero-vector-2.svg"
        alt=""
        className="absolute top-full right-0 z-30 size-[80px] object-cover"
      />
      <div className="flex flex-col items-center justify-center max-w-[635px]">
        <h1 className="text-[68px] md-max:text-[48px] font-semibold font-urbanist leading-[80px] text-center bg-clip-text text-transparent bg-gradient-to-br from-white via-white to-[#ADC7FF]">
          {t('hero.title1')}
        </h1>
        <span className="font-grotesk font-bold text-[92px] md-max:text-[42px] md-max:font-extrabold text-center md-max:leading-[80px] -mt-8 bg-clip-text text-transparent bg-gradient-to-br from-[#ADC7FF] via-white to-white">
          {t('hero.title2')}
        </span>
        <div className="lg:hidden flex flex-col gap-1 mb-4">
          <div className="flex gap-4 p-1">
            <HeroPill
              title={t('hero.pill4')}
              subTitle={t('hero.subPill4')}
              count={"1000"}
              icon={"hero-icon-1.png"}
            />
            <HeroPill
              title={t('hero.pill1')}
              subTitle={t('hero.subPill1')}
              count={"10"}
              icon={"hero-icon-2.png"}
            />
          </div>
          <div className="flex gap-4 p-1 ml-4">
            <HeroPill
              title={t('hero.pill3')}
              subTitle={t('hero.subPill3')}
              count={"97"}
              percent={true}
              icon={"hero-icon-3.png"}
            />
            <HeroPill
              title={t('hero.pill2')}
              subTitle={t('hero.subPill2')}
              count={"1500"}
              icon={"hero-icon-4.png"}
            />
          </div>
        </div>
        <p className="text-[22px] md-max:text-[16px] text-center md-max:max-w-[90%]">
          {t('hero.description')}
        </p>
        <button
          onClick={handleTakeTest}
          className="py-5 px-8 mt-8 bg-white rounded-xl text-black text-lg md-max:text-sm cursor-pointer z-50 relative hover:bg-white/90 hover:scale-105 duration-200"
        >
          {t('hero.button')}
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
